import React from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '../../auth/AuthGuard';
import HorizontalNavigation from './HorizontalNavigation';
import Header from './Header';
import Breadcrumb from '../common/Breadcrumb';

const AppLayout: React.FC = () => {
  return (
    <AuthGuard>
      <div className="min-h-screen bg-gray-900 flex flex-col">
        {/* Header */}
        <Header />

        {/* Horizontal Navigation */}
        <HorizontalNavigation />

        {/* Main Content */}
        <main className="flex-1 bg-gray-900">
          {/* Breadcrumb Navigation - Aligned with horizontal navigation and matter content */}
          <div className="max-w-7xl mx-auto px-6 pt-2 pb-1">
            <Breadcrumb showHomeIcon={false} />
          </div>
          
          {/* Page Content */}
          <div className="max-w-7xl mx-auto px-6 py-2">
            <Outlet />
          </div>
        </main>
      </div>
    </AuthGuard>
  );
};

export default AppLayout;
